"use client";

import React from "react";
import { usePathname } from "next/navigation";
import configData from "@/api/config.json";

const toTitle = (slug: string) =>
    slug
        .split("-")
        .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
        .join(" ");

const BreadcrumbsJsonLd: React.FC = () => {
    const pathname = usePathname() || "/";
    const segments = pathname.split("/").filter(Boolean);
    const site = (configData.meta.site_url || "").replace(/\/$/, "");

    const items = [
        {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: `${site}/`,
        },
        ...segments.map((seg, idx) => ({
            "@type": "ListItem",
            position: idx + 2,
            name: toTitle(seg),
            item: `${site}/${segments.slice(0, idx + 1).join("/")}`,
        })),
    ];

    const json = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items,
    };

    return (
        <script
            type="application/ld+json"
            suppressHydrationWarning
            dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
        />
    );
};

export default BreadcrumbsJsonLd;
